var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-right btngroup top_buttons global_components"},[_c('button',{staticClass:"btn deleteBtn btn-secondary btn-lg",attrs:{"type":"button"},on:{"click":_vm.DeleteFunction}},[_vm._v(" Delete ")]),_c('button',{staticClass:"btn addBtn ml-3",attrs:{"type":"button"},on:{"click":_vm.AddFunction}},[_vm._v(" Create ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }